import { abinsulaLinks } from './abinsulaLinks';

export const STEPS = {
  waiting: 'waiting',
  notlogged: 'notlogged',
  logged: 'logged',
  offers: 'offers',
  payment: 'payment',
  thankyou: 'thankyou',
  subscribed: 'subscribed',
};

export const TESTATE = {
  qn: {
    name: 'qn',
    capability: 'premium-quotidiano.net',
    title: 'Quotidiano.NET',
    color: '#e91701',
    urlPurchaseSfogliatore: abinsulaLinks.qn.sfogliatore,
    urlPurchaseCarta: abinsulaLinks.qn.carta,
  },
  ilresto: {
    name: 'ilresto',
    capability: 'premium-ilrestodelcarlino.it',
    title: 'il Resto del Carlino',
    color: '#007bc7',
    urlPurchaseSfogliatore: abinsulaLinks.ilresto.sfogliatore,
    urlPurchaseCarta: abinsulaLinks.ilresto.carta,
  },
  ilgiorno: {
    name: 'ilgiorno',
    capability: 'premium-ilgiorno.it',
    title: 'il Giorno',
    color: '#007bc7',
    urlPurchaseSfogliatore: abinsulaLinks.ilgiorno.sfogliatore,
    urlPurchaseCarta: abinsulaLinks.ilgiorno.carta,
  },
  iltelegrafo: {
    name: 'iltelegrafo',
    capability: 'premium-lanazione.it',
    title: 'il Telegrafo',
    color: '#9d1a33',
    urlPurchaseSfogliatore: abinsulaLinks.lanazione.sfogliatore,
    urlPurchaseCarta: abinsulaLinks.lanazione.carta,
  },
  lanazione: {
    name: 'lanazione',
    capability: 'premium-lanazione.it',
    title: 'la Nazione',
    color: '#007bc7',
    urlPurchaseSfogliatore: abinsulaLinks.lanazione.sfogliatore,
    urlPurchaseCarta: abinsulaLinks.lanazione.carta,
  },
};
